import { createSlice } from '@reduxjs/toolkit';

const initialState = { logs: [] };

export const vendLogs = createSlice({
    name: 'vendLogs',
    initialState,
    reducers: {
        setVendLogs: (state, action) => {
            state.logs.push(action.payload);
        },
        setFlushLogs: (state) => {
            state.logs = []
        },
    },
});

export const { setVendLogs, setFlushLogs } = vendLogs.actions;
export default vendLogs.reducer;
